function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.string.bold.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.regexp.exec.js";
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
import React from 'react';
import { Accordion, Box } from '@applyboard/ui-components';
import { Flex, Card, Tag, Text, Link } from '@applyboard/crystal-ui';
import { useCurrentUser, useEventTracker } from '@applyboard/ui-utils';
import { useValueAddedServices } from "../../data/valueAddedServices";
export function ValueAddedServices(_ref) {
  var showApplyShop = _ref.showApplyShop,
    showGic = _ref.showGic,
    showLoan = _ref.showLoan,
    programId = _ref.programId,
    programName = _ref.programName,
    schoolId = _ref.schoolId,
    schoolName = _ref.schoolName;
  var displayedVasCards = [].concat(_toConsumableArray(showGic ? ['GIC'] : []), _toConsumableArray(showLoan ? ['LOANS'] : []), _toConsumableArray(showApplyShop ? ['APPLYSHOP'] : []));
  return /*#__PURE__*/React.createElement(Accordion, {
    items: [{
      title: 'ApplyBoard Services',
      content: /*#__PURE__*/React.createElement(Flex, {
        gap: 6,
        direction: "column"
      }, /*#__PURE__*/React.createElement(ValueAddedServiceCard, {
        programId: programId,
        programName: programName,
        schoolId: schoolId,
        schoolName: schoolName,
        displayedVasCards: displayedVasCards
      })),
      expanded: true
    }]
  });
}
var ValueAddedServiceCard = function ValueAddedServiceCard(_ref2) {
  var programId = _ref2.programId,
    programName = _ref2.programName,
    schoolId = _ref2.schoolId,
    schoolName = _ref2.schoolName,
    displayedVasCards = _ref2.displayedVasCards;
  var _useEventTracker = useEventTracker(),
    trackEvent = _useEventTracker.trackEvent;
  var _useCurrentUser = useCurrentUser(),
    _useCurrentUser2 = _slicedToArray(_useCurrentUser, 1),
    currentUser = _useCurrentUser2[0];
  var _useValueAddedService = useValueAddedServices(),
    isLoadingValueAddedServices = _useValueAddedService.isLoadingValueAddedServices,
    valueAddedServicesError = _useValueAddedService.valueAddedServicesError,
    valueAddedServices = _useValueAddedService.valueAddedServices;
  var showCommissionTag = currentUser && currentUser.role !== 'student';
  if (isLoadingValueAddedServices || valueAddedServicesError) {
    return null;
  }

  // filter the value added services based on the displayedVasCards that is controlled by the feature flags:
  var displayedValueAddedServices = valueAddedServices.filter(function (service) {
    return displayedVasCards.includes(service.id.toUpperCase());
  });
  return /*#__PURE__*/React.createElement(React.Fragment, null, displayedValueAddedServices.map(function (service) {
    return /*#__PURE__*/React.createElement(Card, {
      key: service.id,
      as: "article",
      "aria-label": "value-added-service-".concat(service.id)
    }, /*#__PURE__*/React.createElement(Card.Image, {
      alt: "card-image-".concat(service.id),
      src: "",
      height: 165,
      gradient: service.gradient
    }, /*#__PURE__*/React.createElement(Flex, {
      justify: "center",
      direction: "column",
      height: "fill"
    }, service.titles.map(function (line, lineIndex) {
      return /*#__PURE__*/React.createElement(Box, {
        mt: lineIndex > 0 ? -2 : 0,
        key: lineIndex
      }, /*#__PURE__*/React.createElement(Flex, {
        gap: 0,
        direction: {
          xs: 'row',
          md: 'column',
          lg: 'row'
        }
      }, line.map(function (word) {
        return /*#__PURE__*/React.createElement(Text, {
          variant: "headlineM",
          contrast: "inverted",
          key: word.text
        }, /*#__PURE__*/React.createElement("span", {
          style: {
            fontWeight: word.bold ? 600 : 400,
            fontFamily: 'Montserrat'
          }
        }, word.text));
      })));
    }))), /*#__PURE__*/React.createElement(Flex, {
      gap: 2,
      direction: "column"
    }, showCommissionTag && /*#__PURE__*/React.createElement(Flex.Item, null, service.prompts.map(function (prompt) {
      return /*#__PURE__*/React.createElement(Tag, {
        key: prompt.id,
        intent: prompt.intent
      }, prompt.title);
    })), /*#__PURE__*/React.createElement(Flex.Item, null, /*#__PURE__*/React.createElement(Text, {
      variant: "titleS"
    }, service.header), /*#__PURE__*/React.createElement(Text, {
      variant: "bodyS",
      contrast: "mid"
    }, service.description)), /*#__PURE__*/React.createElement(Flex.Item, null, service.links.map(function (link) {
      return /*#__PURE__*/React.createElement(Text, {
        key: link.id,
        variant: "bodyS"
      }, /*#__PURE__*/React.createElement(Link, {
        href: link.url,
        mode: "override_user_choice_and_open_in_new_tab",
        variant: "standalone",
        onClick: function onClick() {
          return trackEvent({
            event: 'VAS card clicked',
            data: {
              source: 'Program Landing Page',
              vasType: service.type,
              clickedUrl: link.url,
              displayedVasCards: displayedVasCards,
              programId: programId,
              programName: programName,
              schoolId: schoolId,
              schoolName: schoolName
            }
          });
        }
      }, link.text));
    }))));
  }));
};